angular.module("ainapp")
    .controller("bulkCashPaymentsController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            //            $scope.PageName = "Bulk Delivery Note";
            //            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            //            if ($scope.TokenInfo == null) {
            //                $state.go("login");
            //            } else {
            //                $scope.checkUserPageAccess($scope.PageName);
            //            }

            $scope.Init = function () {

                $scope.VoucherList = [];


            }
            $scope.Init();


            var oFileIn;

            $(function () {
                oFileIn = document.getElementById('my_file_input');
                if (oFileIn.addEventListener) {
                    oFileIn.addEventListener('change', filePicked, false);
                }
            });

            function filePicked(oEvent) {
                var oFile = oEvent.target.files[0];
                var sFilename = oFile.name;
                var reader = new FileReader();

                reader.onload = function (e) {
                    var data = e.target.result;
                    var cfb = XLSX.read(data, {
                        type: 'binary'
                    });
                    console.log(cfb)
                    $scope.VoucherList = [];

                    cfb.SheetNames.forEach(function (sheetName) {
                        var sCSV = XLS.utils.make_csv(cfb.Sheets[sheetName]);
                        var oJS = XLS.utils.sheet_to_json(cfb.Sheets[sheetName]);
                        //.replace(/-/g, "/");
                        angular.forEach(oJS, function (e) {

                            var voucher = {
                                Date: e.Date,
                                VoucherNo: e.VoucherNo,
                                CashAccount: e.CashAccount,
                                AccountCode: e.AccountCode,
                                AccountName: e.AccountName,
                                Remarks: e.Remarks,
                                Amount: parseFloat(e.Amount),
                            }

                            $scope.VoucherList.push(voucher);
                        });


                        $scope.$apply();
                    });
                };

                reader.readAsBinaryString(oFile);
            }



            $scope.uploadProducts = function () {

                var temp = "";
                angular.forEach($scope.VoucherList, function (e) {

                    if (e.Date == null || e.Date == "" || e.Date == undefined) {
                        temp = "Date Invalid";
                    } else if (e.AccountName == null || e.AccountName == "" || e.AccountName == undefined || e.AccountCode == null ||
                        e.AccountCode == "" || e.AccountCode == undefined) {
                        temp = "Account Details Invalid";
                    } else if (e.VoucherNo == null || e.VoucherNo == "" || e.VoucherNo == undefined) {
                        temp = "Voucher No Invalid";
                    } else if (e.CashAccount == null || e.CashAccount == "" || e.CashAccount == undefined) {
                        temp = "Cash Account Invalid";
                    } else if (!e.Amount > 0) {
                        temp = "Amount Invalid";
                    }
                })

                if (temp == 1) {
                    toastr.warning(temp);
                } else {

                    var salesinvs = [];

                    angular.forEach($scope.VoucherList, function (e) {

                        var olddata = null;
                        angular.forEach(salesinvs, function (ee) {
                            if (ee.VoucherNo == e.VoucherNo) {
                                olddata = ee;
                            }
                        })

                        if (olddata == null) {
                            var sales = {
                                DateString: e.Date,
                                CashAccount: e.CashAccount,
                                VoucherNo: e.VoucherNo,
                                UploadDetails: [],
                            }
                            var det = {
                                AccountCode: e.AccountCode,
                                AccountName: e.AccountName,
                                Remarks: e.Remarks,
                                Amount: e.Amount,
                            }
                            sales.UploadDetails.push(det);
                            salesinvs.push(sales);
                        } else {
                            var det = {
                                AccountCode: e.AccountCode,
                                AccountName: e.AccountName,
                                Remarks: e.Remarks,
                                Amount: e.Amount,
                            }
                            olddata.UploadDetails.push(det);
                        }


                    })

                    console.log(salesinvs);

                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.UploadCashPayment(salesinvs).then(function (response) {
                        if (response.data == "Success") {
                            toastr.success("Success");
                            $scope.Init();
                        } else {
                            toastr.warning(response.data);
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }


            }



        }])
